import { Stack, Typography } from '@mui/material';
import theme from '../../theme';
import { Bookmark } from '@mui/icons-material';

const BookmarkCount = ({ bookmarkCount, variant = 'card' }) => {
  const iconSizes = {
    card: { xs: 12, md: 16 },
    detail: 16,
    compact: 12,
    reviewDetail: 20,
  };

  const typoFontSizes = {
    card: { xs: 12, md: 14 },
    detail: 14,
    compact: 12,
    reviewDetail: 14,
  };

  const iconSize = iconSizes[variant];
  const typoFontSize = typoFontSizes[variant];

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Bookmark sx={{ fontSize: iconSize, color: theme.palette.black[3] }} />
      <Typography
        sx={{ fontSize: typoFontSize, color: theme.palette.black[4], whiteSpace: 'nowrap' }}
      >
        {bookmarkCount}
      </Typography>
    </Stack>
  );
};

export default BookmarkCount;
